// src/auth/AuthContext.jsx
import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

const TOKEN_KEY = "ebook_app_jwt";

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(null); // optional, could decode JWT

  const isAuthenticated = !!token;

  const login = (jwtToken) => {
    setToken(jwtToken);
    localStorage.setItem(TOKEN_KEY, jwtToken);
    // Optionally decode JWT to get username, roles, etc.
    // setUser(decodedUser);
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem(TOKEN_KEY);
  };

  useEffect(() => {
    // Future: validate token with backend if needed
  }, []);

  const value = {
    token,
    user,
    isAuthenticated,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return ctx;
}